/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Modal, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { TrashIcon } from '../../assets/icons';
import LabelsPopup from '../LabelsPopup';
import Label from '../Label';

import styles from './ActionsPopup.module.scss';

const DeviceDetail = React.memo(
  ({
    isError,
    device,
    items,
    allLabels,
    labels,
    canEdit,
    onUpdate,
    onLabelAdd,
    onLabelRemove,
    onLabelCreate,
    onLabelUpdate,
    onLabelDelete,
  }) => {
    const [t] = useTranslation();
    const [open, setOpen] = useState(false);

    const handleEditClosePopup = () => {
      setOpen(false);
    };

    const handleEditOpenPopup = () => {
      setOpen(true);
    };

    const handleDeteleDevice = () => {
      const cleanData = {
        lineId: null,
        siteId: null,
      };
      onUpdate(cleanData);
    };

    const listItems = [];
    items.forEach((item) => {
      if (item.modelId === device.modelId) {
        listItems.push(item);
      }
    });

    const labelIds = labels.map((label) => label.id);

    return (
      <>
        <div className={styles.deviceItemWrapper} onClick={handleEditOpenPopup}>
          {canEdit && (
            <Button className={styles.buttonDelete} onClick={handleDeteleDevice}>
              <TrashIcon className={styles.menuIcon} />
            </Button>
          )}
          <div className={`${styles.detailWrapper} ${isError && styles.isError}`}>
            {labels.length > 0 && (
              <div className={styles.listDeviceLabels}>
                {labels.map((label) => (
                  <span key={label.id} className={styles.attachment}>
                    <LabelsPopup
                      key={label.id}
                      items={allLabels}
                      currentIds={labelIds}
                      onSelect={onLabelAdd}
                      onDeselect={onLabelRemove}
                      onCreate={onLabelCreate}
                      onUpdate={onLabelUpdate}
                      onDelete={onLabelDelete}
                    >
                      <Label
                        size="tiny"
                        name={label.name}
                        color={label.color}
                        isDisabled={!canEdit}
                      />
                    </LabelsPopup>
                  </span>
                ))}
              </div>
            )}
            <div className={`${styles.detailHeader} ${labels.length > 0 && styles.haveLabels}`}>
              {device.name}
            </div>
            <div className={styles.detailContent}>
              <ul className={styles.listItems}>
                {listItems.map((item) => {
                  if (item.basic) {
                    return (
                      <li key={item.id}>
                        <div className={styles.label}>{item.name}</div>
                        <div className={styles.contentValue}>
                          <div className={styles.value}>
                            {device.status === 0 && !Number.isNaN(device.items?.[item.itemName] * 1)
                              ? (device.items?.[item.itemName] * 1).toLocaleString('en-GB', {
                                  minimumFractionDigits: item.decimalPoint,
                                  maximumFractionDigits: item.decimalPoint,
                                })
                              : '-'}
                          </div>
                          <div className={styles.unit}>{item.unitName}</div>
                        </div>
                      </li>
                    );
                  }
                  return '';
                })}
              </ul>
            </div>
          </div>
        </div>
        <Modal closeIcon size="tiny" open={open} onClose={handleEditClosePopup}>
          <div className={`${styles.detailWrapper} ${isError && styles.isError}`}>
            <div className={styles.attachments}>
              <div className={styles.text}>
                {`${t('common.labels', {
                  context: 'title',
                })}: `}
              </div>
              <div className={styles.listLabels}>
                {labels.map((label) => (
                  <span key={label.id} className={styles.attachment}>
                    <LabelsPopup
                      key={label.id}
                      items={allLabels}
                      currentIds={labelIds}
                      onSelect={onLabelAdd}
                      onDeselect={onLabelRemove}
                      onCreate={onLabelCreate}
                      onUpdate={onLabelUpdate}
                      onDelete={onLabelDelete}
                    >
                      <Label
                        size="small"
                        name={label.name}
                        color={label.color}
                        isDisabled={!canEdit}
                      />
                    </LabelsPopup>
                  </span>
                ))}
              </div>
              {canEdit && (
                <LabelsPopup
                  items={allLabels}
                  currentIds={labelIds}
                  onSelect={onLabelAdd}
                  onDeselect={onLabelRemove}
                  onCreate={onLabelCreate}
                  onUpdate={onLabelUpdate}
                  onDelete={onLabelDelete}
                >
                  <button type="button" className={classNames(styles.attachment, styles.dueDate)}>
                    <Icon name="add" size="small" className={styles.addAttachment} />
                  </button>
                </LabelsPopup>
              )}
            </div>
            <div className={styles.detailHeader}>{device.name}</div>
            <div className={styles.detailContent}>
              <ul className={styles.listItems}>
                {listItems.map((item) => (
                  <li key={item.id}>
                    <div className={styles.label}>{item.name}</div>
                    <div className={styles.contentValue}>
                      <div className={styles.value}>
                        {device.status === 0 && !Number.isNaN(device.items?.[item.itemName] * 1)
                          ? parseFloat(device.items?.[item.itemName]).toLocaleString('en-GB', {
                              minimumFractionDigits: item.decimalPoint,
                              maximumFractionDigits: item.decimalPoint,
                            })
                          : '-'}
                      </div>
                      <div className={styles.unit}>{item.unitName}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Modal>
      </>
    );
  },
);

DeviceDetail.propTypes = {
  isError: PropTypes.bool.isRequired,
  device: PropTypes.objectOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  allLabels: PropTypes.arrayOf(PropTypes.any).isRequired,
  labels: PropTypes.arrayOf(PropTypes.any).isRequired,
  canEdit: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onLabelAdd: PropTypes.func.isRequired,
  onLabelRemove: PropTypes.func.isRequired,
  onLabelCreate: PropTypes.func.isRequired,
  onLabelUpdate: PropTypes.func.isRequired,
  onLabelDelete: PropTypes.func.isRequired,
};

export default DeviceDetail;
